export default __webpack_public_path__ + "static/media/pdf.9125447e.svg";